import { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Action, Dispatch } from 'redux';

import lang from '../../../lib/language';
import { RootState } from '../../../lib/store';
import { getCompanyLogoAndName as getLogoAndName } from '../../../lib/store/fundamental';
import { mapUserFavouriteStocksData } from '../../../lib/store/selectors';

import CapitalEmptyImage from '../../../assets/img/image_empty.svg';
import Button from '../../../shared_components/Button/Button';
import { ButtonTypesEnum } from '../../../shared_components/Button/Button.types';
import { UI_ROUTES } from '../../../util/routes';

import WatchListTable from './WatchListTable';

import styles from '../WatchList.module.scss';

type Props = ReduxProps;

const FavouritesWatchList = (props: Props) => {
  const { companyLogoAndName, favouriteStocks, getCompanyLogoAndName } = props;

  const navigate = useNavigate();

  useEffect(() => {
    const missingSymbols = favouriteStocks.filter(symbol => !companyLogoAndName[symbol]?.name);

    if (missingSymbols.length) {
      getCompanyLogoAndName(missingSymbols.join());
    }
  }, [companyLogoAndName, favouriteStocks, getCompanyLogoAndName]);

  const dataStocks = favouriteStocks.map(symbol => ({
    symbol,
    companyName: companyLogoAndName[symbol]?.name,
    url: companyLogoAndName[symbol]?.url,
  }));

  return (
    <>
      {
        dataStocks.length === 0
          ? (
            <div className={styles.wrapperNoFavouritesStocks}>
              <img className={styles.noMessagesLogo} src={CapitalEmptyImage} alt="no messages logo" />
              <p className={styles.noStocksMessage}>{lang.commonWatchlistFavoutesLimit()}</p>
              <p className={styles.noStocksMessage}>
                {lang.commonSee()}
                {' '}
                <Button variant={ButtonTypesEnum.Link} onClick={() => navigate(UI_ROUTES.discover)}>
                  {lang.commonDiscoverTitle()}
                </Button>
              </p>
              <div className={styles.wrapperBtnDiscover}>
                <p>{`${lang.commonAnd()} ${lang.commonMyAccountNoStocksMessage2().replace(lang.commonDiscoverTitle().toLowerCase(), '')}`}</p>
              </div>
            </div>
          )
          : <WatchListTable hasSwipeableRows watchListStocks={dataStocks} />
       }
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  companyLogoAndName: state.fundamental.companyLogoAndName,
  favouriteStocks: mapUserFavouriteStocksData(
    state.marketData.favouriteStocks,
    state.crm.individualExtendedInfo?.user_correlation_id,
  ),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  getCompanyLogoAndName: (symbols: string) => dispatch(getLogoAndName(symbols)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(FavouritesWatchList);
